export { default as DescriptionDekstop } from "./description-dekstop";
export { default as DescriptionMobile } from "./description-mobile";
export { default as ImageDekstop } from "./image-dekstop";
export { default as ImageMobile } from "./image-mobile";
